import { ProductCategoryList, ProductCategoryCreate, ProductCategoryEdit } from './pages';
import Paths from './paths';
import { default as Translations } from './lang/hu';

const name = 'productCategory';

const icon = 'fa-sitemap';

export default {
    pages: {
        ProductCategoryList,
        ProductCategoryCreate,
        ProductCategoryEdit,
    },
    paths: {
        ...Paths,
    },
    translations: {
        ...Translations,
    },
    name,
    icon,
};

export { default as Paths } from './paths';



// WEBPACK FOOTER //
// ./src/modules/ProductCategory/index.ts